import Error404 from '../src/components/Error404';
import { jsx as _jsx } from "react/jsx-runtime";
export var __N_SSG = true;
export default function Custom404() {
  return /*#__PURE__*/_jsx(Error404, {
    e2eid: "pages_404_Error404"
  });
}